import {timeUtil} from '@px/helper/time';

const KEY = 'TIP_ONTARIAN';

export function shouldTip() {
  const today = timeUtil.formatUTCDate(Date.now());
  return localStorage.getItem(KEY) !== today;
}

export function writeLastTipTime() {
  const today = timeUtil.formatUTCDate(Date.now());
  return localStorage.setItem(KEY, today);
}
